/**
 * Connection Event Payload Schemas
 *
 * Zod schemas for integration auth connection event payloads.
 */

import { z } from 'zod';

// =============================================================================
// Connection Event Payload Schemas
// =============================================================================

export const ConnectionRequiredPayloadSchema = z.object({
  taskId: z.string().min(1),
  toolkit: z.string().min(1),
  authUrl: z.string().optional(),
});

// Phase 9: ConnectionResolvedPayloadSchema deleted — OAuth completion now
// flows through INTERACTION_RESPONSE for kind:'composio_auth'.
